import { useContext, useMemo, useCallback } from 'react';
import { AppContext } from '@/context/AppContext';
import KeywordCard from './KeywordCard';
import EmptyState from '@/components/shared/EmptyState';

export default function KeywordGrid() {
  const { rankings, rankingHistory, activeClientId, activeCityFilter } = useContext(AppContext);

  const clientRankings = useMemo(() => {
    return rankings[activeClientId] || [];
  }, [rankings, activeClientId]);

  const clientHistory = useMemo(() => {
    return rankingHistory[activeClientId] || [];
  }, [rankingHistory, activeClientId]);

  const filteredRankings = useMemo(() => {
    if (activeCityFilter === 'all') return clientRankings;
    return clientRankings.filter(r => r.location === activeCityFilter);
  }, [clientRankings, activeCityFilter]);

  const getKeywordHistory = useCallback((keyword, location) => {
    return clientHistory
      .filter(h => h.keyword === keyword && h.location === location)
      .sort((a, b) => new Date(a.scanned_at) - new Date(b.scanned_at));
  }, [clientHistory]);

  if (filteredRankings.length === 0) {
    return (
      <EmptyState
        icon="🔍"
        title="No Rankings Found"
        message={activeCityFilter === 'all' 
          ? "Run a scan to see your keyword rankings." 
          : `No keywords tracked for ${activeCityFilter}.`
        }
      />
    );
  }

  return (
    <div 
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-3 sm:gap-4"
      data-testid="keyword-grid"
    >
      {filteredRankings.map((ranking, index) => (
        <KeywordCard
          key={`${ranking.keyword}-${ranking.location}`}
          ranking={ranking}
          history={getKeywordHistory(ranking.keyword, ranking.location)}
          index={index}
        />
      ))}
    </div>
  );
}
